import React from 'react';
import {mainGreen} from 'styles/variables';

const Tick = props => {
    return (
        <svg width='20' height='20' viewBox='0 0 20 20' {...props}>
            <path
                fill={mainGreen}
                d='M7.884 8.362L14.827 15.207 13.592 16.425 5.415 8.363 10.363 3.484 11.598 4.701z'
                transform='rotate(-90 10.121 9.954)'
            />
        </svg>
    );
};

export default Tick;
